export const Y = "#FFD60A";
export const AD = 0.4;
export const ASPECTS = [["9:16", 9 / 16], ["16:9", 16 / 9], ["1:1", 1], ["4:5", 4 / 5]];
export const EMOJIS = ["🔥", "😂", "😮", "❤️", "👀", "💯", "✨", "🤯", "🏆", "⚡", "👏", "💀", "👑", "🚀", "🎯", "⭐", "😎", "🥶", "😭", "🙌", "💥", "🎉", "📈", "💰", "🗿", "🤡", "😈", "🫡", "🫠", "🥹", "🤌", "🙏", "🧠", "🤑", "😤", "🤫", "🥵", "🤝", "🎬", "📢", "❗", "❓", "✅", "❌", "⏰", "💎"];
const GIF_IDS = [
  "26ufdipQqU2lhNA4g", "3o7aCSPqXE5C6T8tBC", "l3q2K5jinAlChoCLS", "3oEjI6SIIHBdRxXI40", "10JhviFuU2gWD6", "11sBLVxNs7v6WA",
  "13CoXDiaCcCoyk", "1BXa2alBjrCXC", "1Z02vuppxP1Pa", "26BRuo6sLetdllPAQ", "26n6WywJyh39n1pBu", "26tPplGWjN0xLybiU",
  "26u4cqiYI30juCOGY", "3NtY188QaxDdC", "3o7TKSjRrfIPjeiVyM", "3o7abKhOpu0NwenH3O", "3o7btPCcdNniyf0ArS", "3o85xIO33l7RlmLR4I",
  "3oKIPnAiaMCws8nOsE", "6nWhy3ulBL7GSCvKw6", "BPJmthQ3YRwD6QqcVD", "GeimqsH0TLDt4tScGw", "Is1O1TWV0LEJi", "JIX9t2j0ZTN9S",
  "QMHoU66sBXqqLqYvGO", "TdfyKrN7HGTIY", "Ty9Sg8oHghPWg", "VbnUQpnihPSIgIXuZv", "WRQBXSCnEFJIuxktnw", "YTbZzCkRQCEJa",
  "ZqlvCTNHpqrio", "a5viI92PAF89q", "fnuSiwXMTV3zmYDf6k", "jUwpNzg9IcyrK", "kyLYXonQYYfwYDIeZl", "l0HlvtIPzPdt2usKs",
  "l0MYt5jPR6QX5pnqM", "mGK1g88HZRa2FlKGbz", "tHIRLHtNwxpjIFqPdV", "xT0xeJpnrWC4XWblEk",
];
export const GIFS = GIF_IDS.map((id) => ({ id, thumb: `https://i.giphy.com/media/${id}/200w.gif`, url: `https://i.giphy.com/media/${id}/giphy.gif` }));
export const STICKERS = GIFS.map((g) => g.url);
export const MEMES = [
  ["6 7 🤷", "#FFD60A"], ["AURA +1000", "#A78BFA"], ["AURA FARMING", "#38BDF8"], ["CHILL GUY 😌", "#FFFFFF"], ["DELULU", "#F472B6"],
  ["POV:", "#FFFFFF"], ["NPC MODE", "#94A3B8"], ["BRAINROT 🧠", "#F472B6"], ["COOKED 💀", "#FB923C"], ["IT'S GIVING ✨", "#FDE047"],
  ["RIZZ", "#F43F5E"], ["W", "#22C55E"], ["L", "#EF4444"], ["RATIO", "#FFFFFF"], ["NO CAP 🧢", "#60A5FA"], ["FR FR", "#FFFFFF"],
  ["SIGMA 🗿", "#E5E7EB"], ["MEWING 🤫", "#C4B5FD"], ["BRO THINKS 😭", "#FFFFFF"], ["LOCK IN 🔒", "#FFD60A"], ["TUNG TUNG SAHUR", "#D97706"],
  ["LABUBU 🧸", "#F9A8D4"], ["CLANKER 🤖", "#9CA3AF"], ["SKILL ISSUE", "#EF4444"], ["MAIN CHARACTER", "#FDE047"], ["PLOT TWIST 😱", "#F97316"],
  ["WAIT FOR IT...", "#FFFFFF"], ["NAH 💀", "#FFFFFF"], ["SHEESH 🥶", "#67E8F9"], ["GG", "#22C55E"], ["STRAIGHT FIRE 🔥", "#FB923C"], ["OK BUT WHY?", "#FFFFFF"],
];
export const FILTERS = {
  none: "none", warm: "sepia(.3) saturate(1.3)", cold: "hue-rotate(-15deg) saturate(1.2) brightness(1.05)",
  bw: "grayscale(1)", cine: "contrast(1.15) saturate(.9) brightness(.95)",
};
export const TRANSITIONS = [
  ["none", "Ninguna"], ["fade", "Fundido"], ["fadeblack", "A negro"], ["dissolve", "Disolver"],
  ["slideleft", "Deslizar ←"], ["slideright", "Deslizar →"], ["slideup", "Deslizar ↑"], ["wipeleft", "Barrido"],
  ["circleopen", "Círculo"], ["zoomin", "Zoom"], ["pixelize", "Píxeles"], ["radial", "Radial"],
];
export const ANIM_IN = [["none", "Ninguna"], ["fade", "Aparecer"], ["slide-up", "Subir"], ["slide-left", "Entrar →"], ["zoom", "Zoom"]];
export const ANIM_OUT = [["none", "Ninguna"], ["fade", "Desvanecer"], ["slide-down", "Bajar"], ["zoom", "Zoom"]];
export const TEXT_PRESETS = [
  ["Clásico", { color: "#FFFFFF", stroke: true }], ["Neón", { color: "#39FF14", stroke: true }],
  ["Amarillo", { color: "#FFD60A", stroke: true }], ["Rosa", { color: "#FF2D95", stroke: false }],
];

export const FONTS = [
  ["default", "Clásica", "'Arial Black', 'Helvetica Neue', Arial, sans-serif", 900], ["Montserrat", "Montserrat", "Montserrat, sans-serif", 800],
  ["Anton", "Anton", "Anton, sans-serif", 400], ["Bebas Neue", "Bebas", "'Bebas Neue', sans-serif", 400],
  ["Bangers", "Bangers", "Bangers, cursive", 400], ["Luckiest Guy", "Luckiest", "'Luckiest Guy', cursive", 400],
  ["Permanent Marker", "Marker", "'Permanent Marker', cursive", 400], ["Pacifico", "Pacifico", "Pacifico, cursive", 400],
  ["Poppins", "Poppins", "Poppins, sans-serif", 900],
];
export const fontCss = (k) => { const f = FONTS.find((x) => x[0] === k) || FONTS[0]; return { fontFamily: f[2], fontWeight: f[3] }; };
export const SUB_STYLES = [
  ["classic", "Clásico", { cs: null, font: "default", color: "#FFFFFF", stroke: true }],
  ["karaoke", "Karaoke", { cs: "karaoke", font: "Montserrat", color: "#FFFFFF", stroke: true, hl: "#FFD60A" }],
  ["pop", "Pop", { cs: "pop", font: "Montserrat", color: "#FFFFFF", stroke: true, hl: "#39FF14" }],
  ["mrbeast", "MrBeast", { cs: "mrbeast", font: "Luckiest Guy", color: "#FFFFFF", stroke: true, hl: "#FFD60A" }],
  ["neon", "Neón", { cs: "neon", font: "Montserrat", color: "#00E5FF", stroke: false }],
  ["box", "Caja", { cs: "box", font: "Montserrat", color: "#FFFFFF", stroke: false, hl: "#FF2D95" }],
  ["minimal", "Minimal", { cs: "minimal", font: "Montserrat", color: "#FFFFFF", stroke: false, size: 36 }],
];
const EMOJI_MAP = [
  ["💰", "dinero money rico rich millon million euro dolar dollar pagar pay cash"], ["🔥", "fuego fire increible incredible brutal epico epic top"],
  ["❤️", "amor love quiero corazon heart"], ["😂", "jaja haha risa gracioso funny broma joke"], ["👀", "mira look mirad fijate atencion watch"],
  ["🤫", "secreto secret nadie nobody"], ["💡", "idea truco trick tip consejo clave key"], ["🏆", "exito success ganar win ganador winner campeon champion"],
  ["💼", "trabajo work negocio business empresa company jefe boss"], ["⏰", "tiempo time hora hour minuto minute rapido fast"],
  ["🍔", "comida food comer eat hambre hungry"], ["🎵", "musica music cancion song"], ["🚗", "coche car carro"], ["🏠", "casa home house"],
  ["🌍", "mundo world pais country"], ["🧠", "cerebro brain mente mind pensar think inteligente smart"], ["💪", "fuerte strong fuerza gym musculo entrenar train"],
  ["⚠️", "peligro danger cuidado careful error"], ["🤯", "loco crazy locura alucinante mindblowing"], ["😱", "miedo fear terror susto shock"],
  ["😢", "triste sad llorar cry"], ["🚀", "viral cohete crecer grow growth exito"], ["📈", "subir crecimiento aumentar increase ventas sales"],
  ["❓", "pregunta question porque why como how"], ["✅", "correcto correct perfecto perfect funciona works"], ["🎯", "objetivo goal meta target"],
  ["📱", "movil phone telefono tiktok instagram app"], ["🎉", "fiesta party celebrar celebrate feliz happy"],
];
const norm = (w) => w.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
const EMOJI_IDX = EMOJI_MAP.flatMap(([e, ws]) => ws.split(" ").map((w) => [w, e]));
// appends an emoji after the first matching keyword of the caption (one per caption)
export const emojify = (text) => {
  const words = String(text).split(" ");
  for (let i = 0; i < words.length; i++) {
    const n = norm(words[i]);
    const hit = n.length > 2 && EMOJI_IDX.find(([k]) => n === k || (k.length > 4 && n.startsWith(k)));
    if (hit) { words.splice(i + 1, 0, hit[1]); return words.join(" "); }
  }
  return String(text);
};
export const SUB_COLORS = ["#FFFFFF", "#FFD60A", "#39FF14", "#00E5FF", "#FF2D95", "#FF7A00", "#000000"];

export const fmt = (s) => { s = Math.max(0, s || 0); const m = Math.floor(s / 60), r = Math.floor(s % 60); return `${m}:${r.toString().padStart(2, "0")}`; };
export const fmtMs = (s) => `${fmt(s)}.${Math.floor(((s || 0) % 1) * 10)}`;
export const uid = (p) => p + Math.random().toString(36).slice(2, 9);
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
export const clipLen = (c) => (c.out - c.in) / (c.speed || 1);

export function layout(clips) {
  let acc = 0;
  return clips.map((c, k) => {
    const len = clipLen(c);
    let td = 0;
    if (k > 0 && c.transition?.type && c.transition.type !== "none") td = Math.min(c.transition.dur || 0.5, len / 2, clipLen(clips[k - 1]) / 2);
    const start = k === 0 ? 0 : acc - td;
    acc = start + len;
    return { start, len, td };
  });
}
export const totalOf = (lay) => (lay.length ? lay[lay.length - 1].start + lay[lay.length - 1].len : 0);
export const activeIdx = (lay, t) => { for (let k = 0; k < lay.length; k++) if (t < lay[k].start + lay[k].len) return k; return lay.length - 1; };

export function animState(o, t) {
  const p = clamp((t - o.start) / AD, 0, 1), q = clamp((o.end - t) / AD, 0, 1);
  let op = 1, dx = 0, dy = 0, sc = 1;
  if (o.animIn === "fade") op *= p;
  if (o.animIn === "slide-up") dy += (1 - p) * 0.12;
  if (o.animIn === "slide-left") dx += (1 - p) * 0.25;
  if (o.animIn === "zoom") sc *= Math.max(0.05, p);
  if (o.animOut === "fade") op *= q;
  if (o.animOut === "slide-down") dy += (1 - q) * 0.12;
  if (o.animOut === "zoom") sc *= Math.max(0.05, q);
  return { op, dx, dy, sc };
}

export function wrapText(t, n = 26) {
  const out = []; let line = "";
  for (const w of String(t).split(/\s+/)) { if ((line + " " + w).trim().length > n && line) { out.push(line); line = w; } else line = (line + " " + w).trim(); }
  if (line) out.push(line);
  return out.slice(0, 3).join("\n");
}

export const probeDur = (url, kind) => new Promise((res) => {
  const el = document.createElement(kind === "audio" ? "audio" : "video");
  el.preload = "metadata"; el.onloadedmetadata = () => res(el.duration || 0); el.onerror = () => res(0); el.src = url;
});

export async function peaksOf(url, n = 300) {
  try {
    const buf = await (await fetch(url)).arrayBuffer();
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const ab = await ctx.decodeAudioData(buf); ctx.close();
    const d = ab.getChannelData(0), step = Math.max(1, Math.floor(d.length / n)), out = [];
    for (let i = 0; i < n; i++) { let m = 0; for (let j = i * step; j < (i + 1) * step && j < d.length; j += 16) m = Math.max(m, Math.abs(d[j])); out.push(m); }
    const mx = Math.max(...out, 0.01); return out.map((v) => v / mx);
  } catch (e) { return null; }
}
